// ─────────────────────────────────────────────────────────────────────────────
// 判词常量表（Phase 2.1）· 渲染时查表，不入 results.json。
// 10 句为创始人签字版，逐字写入、禁止润色；全角标点。
// 黑名单与禁令词对判词同样生效（已核对：命中为空）。
// 分档：0–39 / 40–59 / 60–74 / 75–89 / 90–100
// ─────────────────────────────────────────────────────────────────────────────

export const VERDICTS = {
  // 恋爱脑浓度
  lianAiNao: [
    { min: 0,  max: 39,  text: "偏低。不是痊愈，是最近没人给你发病的机会。" },
    { min: 40, max: 59,  text: "中度。平时看着正常，手机一震原形毕露。" },
    { min: 60, max: 74,  text: "偏高。嘴上说「没事」的次数，和浓度成正比。" },
    { min: 75, max: 89,  text: "重度。你不是在恋爱，是在值班。" },
    { min: 90, max: 100, text: "满格。这份报告对你只是确认，不是发现。" },
  ],
  // 理智留存
  liZhi: [
    { min: 0,  max: 39,  text: "所剩无几，剩下的专门用来给自己找理由。" },
    { min: 40, max: 59,  text: "剩一半，专挑用不上的时候在线。" },
    { min: 60, max: 74,  text: "大部分在岗，关键时刻集体请假。" },
    { min: 75, max: 89,  text: "几乎满员，所以你的糊涂全是自愿的。" },
    { min: 90, max: 100, text: "满格。用这么清醒的脑子办这么糊涂的事，才是最重的病。" },
  ],
};

// value(0-100) → 该档判词；越界钳制到 [0,100]
export function pickVerdict(kind, value) {
  const list = VERDICTS[kind] || [];
  const v = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
  const hit = list.find((b) => v >= b.min && v <= b.max);
  return hit ? hit.text : "";
}
